<template>
  <app-modal @closeModal="closeModal" containerClass="modal-xlg" class="options-modal">
    <div slot="header">
      <h3>{{ $t('shortcuts') }}</h3>
      <div class="header-actions" data-html2canvas-ignore="true">
        <span class="print fas fa-download" v-on:click="downloadGuidePDF"></span>
        <span class="close fas fa-times" v-on:click="closeModal"></span>
      </div>
    </div>
    <div slot="body">
      <div class="options-content">
        <div v-for="(shortcutSection, i) in shortcutsDisplay" :key="i" style="padding-top: 10px;">
        <h3 v-if="shortcutSection.title">{{shortcutSection.title}}</h3>
        <ul>
          <li v-for="(shortcut, j) in shortcutSection.shortcuts" :key="j">
            <b>{{getDisplayShortcut(shortcut)}}</b> {{shortcut.description}}
          </li>
        </ul>
      </div>
      </div>
      <p class="note" style="padding-top: 10px;">{{SHORTCUT.guide_note}}</p>
    </div>
  </app-modal>
</template>

<script>
  import _ from 'lodash';
  import * as html2pdf from 'html2pdf.js';

  import Modal from '../modal';

  import SHORTCUT from '../../config/shortcut-keys';
  import editor from '../../helpers/editor';

  export default {
    components: {
      'app-modal': Modal
    },
    computed: {
      shortcutsDisplay () {
        return _.sortBy(SHORTCUT.display_guide, ['order'])
      }
    },
    methods: {
      closeModal(e) {
        if(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.$emit('closeModal');
      },

      getDisplayShortcut(shortcut) {
        if(!shortcut.static) {
          return editor.getShortcutAsString(SHORTCUT.shortcuts[shortcut.shortcut]);
        } else {
          return shortcut.shortcut;
        }
      },

      downloadGuidePDF() {
        const element = document.querySelector('#shortcut-modal .modal-container');

        html2pdf(element, {
          margin:       1,
          filename:     'shortcuts-guide.pdf',
          image:        { type: 'jpeg', quality: 0.98 },
          html2canvas:  { dpi: 192, letterRendering: true },
          jsPDF:        { unit: 'cm', format: 'a4', orientation: 'portrait' }
        });
      }
    },
    data () {
      return {
        SHORTCUT: SHORTCUT
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-ui/shortcuts-modal";
</style>